module.exports = __webpack_public_path__ + "static/media/mobileIcons.11f92d82.svg";